<template>
    <div class="column is-four-fifths">
        <div class="mb-3">{{ translate("notification_center.scheduling.choose_time") }}</div>
        <div>
            <div class="control">
                <label class="fontawesome-radio">
                    <input type="radio" name="delayInSec" v-model="delayInSec" :value="5 * 60" />
                    <span>{{ translate("notification_center.scheduling.5_min") }}</span>
                </label>
            </div>

            <div class="control">
                <label class="fontawesome-radio">
                    <input type="radio" name="delayInSec" v-model="delayInSec" :value="60 * 60" />
                    <span>{{ translate("notification_center.scheduling.1_h") }}</span>
                </label>
            </div>

            <div class="control">
                <label class="fontawesome-radio">
                    <input type="radio" name="delayInSec" v-model="delayInSec" :value="8 * 60 * 60" />
                    <span>{{ translate("notification_center.scheduling.8_h") }}</span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    import translatorMixin from "../../Common/translatorMixin";

    export default {
        name: "schedule-sending-step",
        mixins: [translatorMixin],
        computed: {
            delayInSec: {
                set(value) {
                    this.$store.commit("scheduleTime/setChosenDelayInSec", value);
                },
                get() {
                    return this.$store.state.scheduleTime.chosenDelayInSec;
                },
            },
        },
    };
</script>

<style scoped></style>
